import { Modal } from "antd";
import axios from "axios";
import {
  usersApiUpsellProvider,
  expenseReportsListApiUpsellProvider,
  uploadApiUpsellProvider
} from "../../../lib/api/providers";
import { get } from "../utils/utils";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json"
  }
});

const api = {
  attendances() {
    let url = "attendances";
    return {
      progression: (token, args) =>
        instance.post(`/api/${url}/progression`, args, { headers: { Authorization: token } }),
      detailsDay: (token, args) =>
        instance.post(`/api/${url}/details/day`, args, { headers: { Authorization: token } }),
      detailsWeek: (token, args) =>
        instance.post(`/api/${url}/details/week`, args, { headers: { Authorization: token } }),
      validate: (token, args) => instance.post(`/api/${url}/validate`, args, { headers: { Authorization: token } })
    };
  },
  attendance() {
    let url = "attendance";
    return {
      modify: (token, attendance) => instance.put(`/api/${url}`, attendance, { headers: { Authorization: token } })
    };
  },
  trip() {
    let url = "trip";
    return {
      validate: (token, args) => instance.post(`/api/${url}/validate`, args, { headers: { Authorization: token } }),
      modify: (token, trip) => instance.put(`/api/${url}/`, trip, { headers: { Authorization: token } })
    };
  },
  trips() {
    let url = "trips";
    return {
      validate: (token, args) => instance.post(`/api/${url}/validate`, args, { headers: { Authorization: token } })
    };
  },
  vacation() {
    let url = "vacation";
    return {
      validate: () => instance.post(`/api/${url}/validate`),
      reject: () => instance.post(`/api/${url}/reject`),
      delete: () => instance.post(`/api/${url}/delete`)
    };
  },
  vacations() {
    let url = "vacations";
    return {
      progression: () => instance.get(`/api/${url}/progression`),
      detailsDay: (token, args) => instance.post(`/api/${url}/details/day`, args, { headers: { Authorization: token } })
    };
  }
};
export default api;

export const fetchExpenseTypeApi = async token => {
  const response = await instance.post(
    "/api/expensetypes",
    {
      match: { display_form: true },
      project: {
        _id: 1,
        type: 1,
        subtype: 1,
        "à refacturer": 1,
        tva_rules: 1,
        set_address: 1,
        to_reinvoice: 1,
        display_form_terrain: 1
      }
    },
    {
      headers: {
        Authorization: token
      }
    }
  );
  return response.data;
};

export const addExpenseApi = async (expense, token) => {
  const response = await instance.post("/api/expense", expense, {
    headers: {
      Authorization: token
    }
  });

  return response.data;
};

export const updateExpenseApi = async (expense, token) => {
  const response = await instance.put("/api/expense", expense, {
    headers: {
      Authorization: token
    }
  });

  return response.data;
};

export const getUsersWithoutExpensesApi = async (token, args) => {
  const response = await instance.post("/api/expenses//export/withoutexpensesusers", args, {
    headers: {
      Authorization: token
    },
    responseType: "arraybuffer"
  });
  return response.data;
};

export const handleFieldError = error => {
  if (error.response) console.log("error", error.response.data);
  let textError = get(["response", "data", "error"], error, "Erreur de traitement");
  const errorData = get(["response", "data", "data", "e"], error, textError);
  const fieldData = get(["response", "data", "data", "fields"], error, []);
  textError = get([fieldData[0], "message"], errorData, textError);

  Modal.error({ title: "Erreur", content: `${textError} ${fieldData ? " (" + fieldData + ")" : ""}` });
  return { title: "Erreur", concent: `${textError} ${fieldData ? " (" + fieldData + ")" : ""}` };
};

export const handleTeamError = error => {
  console.log("handleError", error.response.data);
  let textError = get(["response", "data", "data"], error, "Erreur de traitement");
  const errorData = get(["response", "data", "error"], error, "Erreur");
  Modal.error({ title: errorData, content: textError });
  return { title: errorData, concent: textError };
};
export const handleError = error => {
  const responseData = get(["response", "data"], error);
  if (responseData && typeof responseData.data === "string") return handleTeamError(error);
  return handleFieldError(error);
};
// export const handleError = error => {
//   let message = "La requète n'a pu aboutir";

//   if (get(["response", "status"], error) === 401) {
//     message = get(["response", "data", "error"], error, "la requète n'a pu aboutir, veuillez rééssayer");
//   } else {
//     const field = get(["response", "data", "data", "fields", 0], error);
//     message = get(
//       ["response", "data", "data", "e", field, "message"],
//       error,
//       "la requète n'a pu aboutir, veuillez reéssayer"
//     );
//   }

//   Modal.error({ title: "Erreur", content: message });
// };

export const uploadMedia = async (file, token) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await uploadApiUpsellProvider.post("/", formData, {
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: token
    }
  });
  /*const response = await axios({
    url: process.env.REACT_APP_API + "/api/upload",
    method: "POST",
    data: formData,
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: token
    }
  });*/

  const data = response.data;
  return data;
};
export const fetchDistinctUsers = async (filters, token) => {
  return usersApiUpsellProvider
    .post(`/distincts/email`, filters, {
      headers: {
        Authorization: token
      }
    })
    .then((response = {}) => {
      return response.data;
    })
    .catch(e => {
      console.log(e);
      return [];
    });
};

export const fetchExpensesDisctinctUsers = async (filters, token) => {
  return expenseReportsListApiUpsellProvider
    .post(`/distincts/user_email`, filters, {
      headers: {
        Authorization: token
      }
    })
    .then((response = {}) => {
      return response.data;
    })
    .catch(e => {
      console.log(e);
      return [];
    });
};
export const fetchExpensesDisctinctCompany = async (filters, token) => {
  return expenseReportsListApiUpsellProvider
    .post(`/distincts/user_company_label`, filters, {
      headers: {
        Authorization: token
      }
    })
    .then((response = {}) => {
      return response.data;
    })
    .catch(e => {
      console.log(e);
      return [];
    });
};

export const fetchExpensesDisctinctType = async (filters, token) => {
  return expenseReportsListApiUpsellProvider
    .post(`/distincts/type.def`, filters, {
      headers: {
        Authorization: token
      }
    })
    .then((response = {}) => {
      return response.data;
    })
    .catch(e => {
      console.log(e);
      return [];
    });
};

export const fetchExpensesDisctinctClients = async (filters, token) => {
  return expenseReportsListApiUpsellProvider
    .post(`/distincts/clients.label`, filters, {
      headers: {
        Authorization: token
      }
    })
    .then((response = {}) => {
      return response.data;
    })
    .catch(e => {
      console.log(e);
      return [];
    });
};

export const fetchUsers = async (filters, token) => {
  return usersApiUpsellProvider
    .post("/", filters, {
      headers: {
        Authorization: token
      }
    })
    .then((response = {}) => {
      return response.data;
    })
    .catch(e => {
      console.log(e);
      return [];
    });
};

export const createBonus = async (bonus, token) => {
  const response = await instance.post("/api/bonus", bonus, {
    headers: {
      Authorization: token
    }
  });

  return response.data;
};

export const validateBonus = async (bonus, token) => {
  const response = await instance.post("/api/bonus/validate", bonus, {
    headers: {
      Authorization: token
    }
  });

  return response.data;
};

export const validateBonuses = async (bonusesId, token) => {
  const response = await instance.post(
    "/api/bonuses/validate",
    { _ids: bonusesId },
    {
      headers: {
        Authorization: token
      }
    }
  );

  return response.data;
};

export const rejectBonus = async (bonus, token) => {
  const response = await instance.post("/api/bonus/reject", bonus, {
    headers: {
      Authorization: token
    }
  });

  return response.data;
};

export const deleteBonuses = async (bonusesId, token) => {
  const response = await instance.post("/api/bonuses/remove", bonusesId, {
    headers: {
      Authorization: token
    }
  });

  return response.data;
};
export const updateMealPackage = async (payload, token) => {
  const response = await instance.put("/api/mealpackage", payload, {
    headers: {
      Authorization: token
    }
  });

  return response.data;
};

export const validateMealpackageRequest = async (payload, token) => {
  const response = await instance.post("/api/mealpackages/validate", payload, {
    headers: {
      Authorization: token
    }
  });

  return response.data;
};

export const setClientLimits = async (data, token) => {
  const response = await instance.post("/api/bonuses/limits/setclientlimits", data, {
    headers: {
      Authorization: token
    }
  });

  return response.data;
};
export const setClientAmounts = async (data, token) => {
  const response = await instance.post("/api/bonuses/limits/setclientamounts", data, {
    headers: {
      Authorization: token
    }
  });

  return response.data;
};
export const setUserLimit = async (data, token) => {
  const response = await instance.post("/api/bonuses/limits/setuserlimits", data, {
    headers: {
      Authorization: token
    }
  });

  return response.data;
};
export const setUserAmounts = async (data, token) => {
  const response = await instance.post("/api/bonuses/limits/setuseramounts", data, {
    headers: {
      Authorization: token
    }
  });

  return response.data;
};

export const confirmCutoff = async token => {
  const response = await instance.post(
    "/api/cutoff",
    {},
    {
      headers: {
        Authorization: token
      }
    }
  );

  return response.data;
};

export const getCutoffDate = async token => {
  const response = await instance.get(`/api/cutoff`, {
    headers: {
      Authorization: token
    }
  });

  return response.data;
};

export const getCutoffProvisionalDate = async token => {
  const response = await instance.get("/api/cutoff/next", {
    headers: {
      Authorization: token
    }
  });

  return response.data;
};

export const getCutoffDetails = async token => {
  const response = await instance.get("/api/cutoff/todo", {
    headers: {
      Authorization: token
    }
  });

  return response.data;
};

export const updateNextCutoffDate = async (token, newDate) => {
  const response = await instance.post("/api/cutoff/next", newDate, {
    headers: {
      Authorization: token
    }
  });

  return response.data;
};

export const generateRegularBonuses = async ({ token, frequency_id, client_id }) => {
  const response = await instance.post(
    "/api/bonuses/generate",
    { frequency_id, client_id },
    {
      headers: {
        Authorization: token
      }
    }
  );
  return response.data;
};

export const validateRegularBonuses = async ({ token, typeId }) => {
  const response = await instance.post(
    "/api/bonuses/validateall",
    {},
    {
      headers: {
        Authorization: token
      }
    }
  );
  return response.data;
};
export const validateAllBonuses = async ({ token, typeId }) => {
  const response = await instance.post(
    "/api/bonuses/validateall",
    { type_id: typeId },
    {
      headers: {
        Authorization: token
      }
    }
  );
  return response.data;
};

export const fetchDistinctUsersFullname = async token => {
  return usersApiUpsellProvider
    .post(
      `/distincts/fullName`,
      {},
      {
        headers: {
          Authorization: token
        }
      }
    )
    .then((response = {}) => {
      return response.data;
    })
    .catch(e => {
      console.log(e);
      return [];
    });
};



// WEBPACK FOOTER //
// src/modules/presence/api/api.js